export const AUXILIAR_MODULE = -1